import { Analytics } from 'cliengo-fe-utils';
import { Account, User } from '@cliengo/mfe-utils/types';

import config from '@/config/environment';

declare global {
  interface Window {
    _hsq: unknown[];
  }
}

const _hsq = (window._hsq = window._hsq || []);

_hsq.push(['setPath', '/dashboard']);
_hsq.push(['trackPageView']);

export const setAnalytics = (account: Account, user: User) => {
  const acc = account as unknown as JsonObject;
  const usr = user as unknown as JsonObject;

  if (Analytics.isInitialized() && Analytics.isAnonymousMode()) {
    Analytics.setTraits(acc, usr);
  } else {
    Analytics.initialize({
      segmentWriteKey: config.SEGMENT_WRITE_KEY,
      account: acc,
      user: usr,
      sendAnalytics: 'YES',
    });
  }

  console.info('Analytics is running');
};

export const setHubspotScript = () => {
  if (process.env.ENVIRONMENT === 'prod') {
    const script = document.createElement('script');

    // Configurar los atributos del script
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js.hs-scripts.com/44736092.js';
    document.head.appendChild(script);

    console.info('Hubspot script loaded!');
  }
};

export const identifyHubspot = (account: Account, user: User) => {
  if (!user.email || process.env.ENVIRONMENT !== 'prod') {
    return;
  }

  const NOT_SET = 'Not set';

  _hsq.push([
    'identify',
    {
      email: user.email,
      id: user.id || NOT_SET,
      companyId: user.companyId || NOT_SET,
      phone: user.phone || NOT_SET,
      language: user.language || NOT_SET,
      whitelabelId: account.whiteLabelId || NOT_SET,
      whitelabelName: account.whiteLabelName || NOT_SET,
      vertical: account.vertical || NOT_SET,
      planType: account.planType || NOT_SET,
      planCurrency: account.planCurrency || NOT_SET,
      affiliate: account.affiliate || NOT_SET,
      affiliateName:
        (account as unknown as JsonObject).affiliateName || NOT_SET,
      affiliateProgramCode: account.affiliateProgramCode || NOT_SET,
    },
  ]);
  console.info('User identified in Hubspot!');
};
